import React from 'react';

import { Button } from '@components';

const AddDeviceButton = ({ onClick, children = 'Add a Device', ...props }) => {
  return (
    <Button {...props} onClick={onClick}>
      {children}
    </Button>
  );
};

export default AddDeviceButton;
